import React from 'react'
import withContainer from '../../HOCs/withContainer'

const NotFound = (props) => {
  return <div>Ups... Sayfa bulunamadı...</div>
}

export default withContainer(NotFound)
